import { tagsInsights } from 'constants/tags';

const defaultInsights = [
  {
    default: 1,
    question: 'What problem is the company solving?',
    tag: tagsInsights[0],
  },
  {
    default: 2,
    question: 'In simple terms, what does your startup product do?',
    tag: tagsInsights[3],
  },
  {
    default: 3,
    question: 'What traction can you demonstrate?',
    tag: tagsInsights[1],
  },
  { default: 4, question: 'Who are your competitors?', tag: tagsInsights[5] },
  {
    default: 5,
    question: 'Why is the product better than its competitors?',
    tag: tagsInsights[7],
  },
  {
    default: 6,
    question: 'How has your product solved the stated problem?',
    tag: tagsInsights[5],
  },
  {
    default: 7,
    question: 'How do you make (or plan to make) money?',
    tag: tagsInsights[7],
  },
  {
    default: 8,
    question: 'How big is the market your product is addressing?',
    tag: tagsInsights[7],
  },
  {
    default: 9,
    question: 'Why did you create this product?',
    tag: tagsInsights[0],
  },
];

export default defaultInsights;
